import type { TranslationTree } from '../../types';
import { admin } from './admin';
import { adminTools } from './adminTools';
import { analytics } from './analytics';
import { auth } from './auth';
import { camera } from './camera';
import { common } from './common';
import { contact } from './contact';
import { errors } from './errors';
import { home } from './home';
import { layout } from './layout';
import { mlRul } from './machineLearning';
import { signals } from './signals';
import { profile } from './profile';
import { settings } from './settings';
import { traceability } from './traceability';
import { toolView } from './toolView';
import { labeling } from './labeling';
import { backendConfig } from './backendConfig';
import { modules } from './modules';
import { administration } from './administration';
import { referenceAliases } from './referenceAliases';
import { toolPickers } from './toolPickers';
import { toolRecommender } from './toolRecommender';

export const fr: TranslationTree = {
  ...common,
  ...layout,
  ...settings,
  ...profile,
  ...home,
  ...contact,
  ...admin,
  ...adminTools,
  ...analytics,
  ...traceability,
  ...toolView,
  ...mlRul,
  ...signals,
  ...auth,
  ...camera,
  ...errors,
  ...labeling,
  ...backendConfig,
  ...modules,
  ...administration,
  ...referenceAliases,
  ...toolPickers,
  ...toolRecommender,
};
